import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 766E10EA-23CD-42BD-9DB8-633FBF8C584A
 * name mustache
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mustache.svg
 * tags
 */
export const MustacheIcon = createSvgIcon(<><path d="M21 12C19 12 18 9 15 9S12 11 12 11 12 9 9 9 5 12 3 12C2 12 1 11 1 11S2 16 6 16C11 16 12 13 12 13S13 16 18 16C22 16 23 11 23 11S22 12 21 12Z" /></>, 'MustacheIcon');
export default MustacheIcon